<ng-container *ngIf="!showViewPNAccountLimit; else viewNaturalPersonAccountLimit">
  <ng-container *ngTemplateOutlet="
  content;
  context: {

  }
">
  </ng-container>
</ng-container>

<ng-template #content>
  <ba-configuration-step [accountsNumber]="accountsNumber"></ba-configuration-step>

  <ng-container *ngIf="agencyDataForm" formGroupName="agencyData">
    <h2 class="title f-regular text-bold">¿D&oacute;nde realizar&aacute;s m&aacute;s operaciones?</h2>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Regi&oacute;n</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="department">
          <ibk-select-option 
            *ngFor="let department of deparments" 
            [value]="department.deparment"
            [label]="department.deparment"
            ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
      <ibk-input-group>
        <label>Provincia</label>
        <ng-container *ngIf="provinces.length > 0; else disabledSelector">
          <ibk-select class="field" dsRxForm="selectChange" formControlName="province">
            <ibk-select-option 
              *ngFor="let province of provinces" 
              [value]="province.province"
              [label]="province.province"
            ></ibk-select-option>
          </ibk-select>
        </ng-container>
      </ibk-input-group>
    </div>

    <div class="grid-xs-column banner-step-generic color-success">
      <img class="banner-step-generic__img" [src]="asset('assets/images/ibk-agente-03.svg')"
      alt="Operaciones bancarias" />
      <br/>
      <br/>
      <div class="banner-step-generic__content banner-step-generic__align-center">
        <span>
          Conocer esta información nos permitirá designar tu región de operaciones bancarias y evitar el pago de comisiones
          interplaza por transacciones desde un lugar diferente al que escogiste. Conoce más sobre las tarifas en
          <span class="text-bold">https://interbank.pe/tasas-tarifas/</span>
        </span>
      </div>
    </div>
    <br/>
    <br/>
  </ng-container>

  <!-- <h1 class="ibk-title">Términos y condiciones</h1> -->
  <br/>
  <ng-container *ngIf="hasConfigDataForm" formGroupName="configData">
    <section class="checkbox-group">
      <ibk-input id="read-terms-conditions">
        <input type="checkbox" formControlName="tAndC" />
        He leído y acepto los
        <a [href]="asset('assets/pdf/Terminos_y_Condiciones_CN_PN.pdf')" target="_blank" class="ibk-link underlined">
          Términos y condiciones
        </a>
        y la
        <a [href]="asset('assets/pdf/Politica_de_Privacidad_CN_PN.pdf')" target="_blank" class="ibk-link underlined">
          Política de Privacidad.
        </a>
      </ibk-input>

      <ibk-input id="authorize-personal-data">
        <input type="checkbox" formControlName="personalData" />
        Autorizo el uso de mis datos personales para finalidades opcionales previstas en la
        <b> Política de privacidad. </b>
      </ibk-input>

      <!-- <ibk-input id="authorize-share-number-account">
        <input type="checkbox" formControlName="accountNumber" />
        Acepto compartir el número de cuenta negocio abierta en Interbank con IZIPAY para que sea asociada a mi perfil
      </ibk-input> -->

      <ibk-input id="receive-account-opening-notification">
        <input type="checkbox" formControlName="accountNumber" />
        Acepto recibir notificaciones de actualizaci&oacute;n del proceso de apertura de cuenta negocio a trav&eacute;s de Whatsapp a mi n&uacute;mero registrado.
      </ibk-input>

      <!-- <ibk-toast type="INFO"> Las Cuentas Corrientes con saldo acreedor no generan intereses </ibk-toast> -->
    </section>
  </ng-container>

  <ibk-toast type="ERROR" *ngIf="showErrorDisclaimer">
    De acuerdo a nuestras políticas internas no podemos atender tu solicitud. Para mayor información puedes comunicarte a
    nuestra Banca Telefónica.
  </ibk-toast>

  <ibk-toast type="WARN" *ngIf="showWarnDisclaimer">
    Ha ocurrido un problema inesperado, por favor intenta en unos minutos.
  </ibk-toast>

  <ibk-button class="ba-action" [loading]="isLoading">
    <button [disabled]="form.invalid || isButtonDisabled" (click)="done()" id="open-business-account-natural-person"
      class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn">
      Abrir Cuenta Negocios
    </button>
  </ibk-button>

  <ng-template #disabledSelector>
    <ibk-select disabled class="field"></ibk-select>
  </ng-template>
</ng-template>
<ng-template #viewNaturalPersonAccountLimit>
  <ba-view-natural-person-account-limit
    (onShowViewConfiguration)="onShowViewConfiguration($event)"></ba-view-natural-person-account-limit>
</ng-template>